import React from 'react';
import styled from 'styled-components';

import Chip from 'components/core/chip';
import { Typography } from 'src/typography';

export function StaffPickChip(): JSX.Element {
  return (
    <StyledChip
      label={
        <Typography.Label tag='span' size='xsmall' weight='bold'>
          {({ t }) => t('marketplace.staff-picks', 'Staff Pick')}
        </Typography.Label>
      }
    />
  );
}

const StyledChip = styled(Chip)`
  &.MuiChip-root {
    background-color: ${({ theme }) => theme.colors.primaryGreen};
    color: ${({ theme }) => theme.colors.white};
  }
`;
